module.exports = __webpack_public_path__ + "img/xbox_wireless_headset.0452ec9.jpg";